module.exports = __webpack_public_path__ + "img/46.5a857f45.jpg";